import { STATUS_LABEL } from "@/lib/format";

export default function StatusBadge({ status }) {
  const cls = {
    masuk: "status-masuk",
    proses: "status-proses",
    selesai: "status-selesai",
    diterima: "status-diterima",
  }[status] || "status-diterima";

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 text-[11px] font-medium border rounded-sm ${cls}`}
      data-testid={`status-badge-${status}`}
    >
      <span className="status-dot mr-1.5 bg-current opacity-70" />
      {STATUS_LABEL[status] || status}
    </span>
  );
}
